// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "7070a7c483fb774beb4d242608d6f39c99d341e1/static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"83cd5b92","98":"c3469f9b","157":"23db090e","215":"28b12c6b","515":"a363df97","777":"dfb468f1","952":"1030e47e"}[chunkId] + ".chunk.js";
};